import * as React from 'react';
import TruncateMarkup from 'react-truncate-markup';
import { ArticleParagraph1, UIText3 } from '@cian/ui-kit';

import * as styles from './CoPromoBottomContent.css';
import { IPromoProp } from '../../../../types/promosPage';

interface ICoPromoBottomContentProps {
  promoProp: IPromoProp | undefined;
  description: string | undefined;
}

export const CoPromoBottomContent: React.FC<ICoPromoBottomContentProps> = ({ promoProp, description }) => {
  if (!promoProp && !description) {
    return null;
  }

  return (
    <div className={styles['bottom-content']}>
      {promoProp && (
        <div className={styles['factoid']}>
          <UIText3 color="gray60_100">{promoProp.title}</UIText3>
          <ArticleParagraph1>{promoProp.value}</ArticleParagraph1>
        </div>
      )}
      {description && (
        <div className={styles['description']}>
          <TruncateMarkup lines={3}>
            <div>{description}</div>
          </TruncateMarkup>
        </div>
      )}
    </div>
  );
};
